import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VhQueryAutoWeb } from 'vhautowebdb';
@Component({
  selector: 'atw-countdown-config',
  templateUrl: './countdown-config.component.html',
  styleUrls: ['./countdown-config.component.scss']
})
export class AtwCountdownConfig implements OnInit {

  @Input() data_tool: any = {};
  @Input() device: string = "";
  @Input() visible_config_tool: boolean = false;
  @Input() isDynamicProduct: any = false;
  @Output() closeConfigEvent = new EventEmitter<any>();

  selectedItem: any;
   constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb
  ) {

  }
  ngOnInit(): void {
  }

  close() {
    this.closeConfigEvent.emit(null)
  }

  updateComponent(id, value) {
    
    this.vhQueryAutoWeb.updateObject(id, value)
      .then((bool) => {
        
      }, error => {
        console.error(error)
      })
  }

  /* Update data styles
    event: fieldname update emmited
  */
  onSaveData(event) {
    this.updateComponent(this.data_tool._id, { [event]: this.data_tool[event] })
    
  }
}
